import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    NoveltySearchPic2TextApi,
    NoveltySearchPic2TextRequest,
    NoveltySearchPic2TextResponseData,
} from '../../novelty-search-pic2text-api';

/**
 * NoveltySearchPic2TextApi 的 Mock 实现
 * @description 用于前端开发，在后端接口未完成时使用
 */
@injectable()
export class NoveltySearchPic2TextApiMock implements NoveltySearchPic2TextApi {
    /**
     * Mock 图片转文本
     * @description 返回模拟的图片描述结果
     */
    async pic2Text(data: NoveltySearchPic2TextRequest): Promise<NoveltySearchPic2TextResponseData> {
        // 模拟 API 延迟 (1-2秒)
        await new Promise(resolve => setTimeout(resolve, 1000 + Math.random() * 1000));

        const imageCount = data.image_url.length;
        const mockMessage = this._generateMockDescription(imageCount, data.background);

        return {
            message: mockMessage,
            role: 'assistant',
            model: data.model_type,
            usage: {
                prompt_tokens: 100 + imageCount * 50,
                image_tokens: imageCount * 200,
                completion_tokens: mockMessage.length,
                total_tokens: 100 + imageCount * 250 + mockMessage.length,
            },
            finish_reason: 'stop',
        };
    }

    /**
     * 生成模拟的图片描述
     */
    private _generateMockDescription(imageCount: number, background?: string): string {
        const baseDescriptions = [
            '本技术方案涉及一种创新的机械结构设计，包括主体框架、连接部件和功能模块。',
            '图中展示了一种电子设备的内部结构，主要包含电路板、传感器阵列和信号处理单元。',
            '该技术方案描述了一种流体控制系统，具有进液口、出液口和调节阀门等核心组件。',
            '图示为一种光学装置的结构示意图，包括光源、透镜组和成像单元等关键部分。',
            '本方案展示了一种新型的数据处理架构，涵盖数据采集、处理和存储等多个功能模块。',
        ];

        const randomIndex = Math.floor(Math.random() * baseDescriptions.length);
        let description = baseDescriptions[randomIndex];

        if (imageCount > 1) {
            description += `\n\n根据所提供的${imageCount}张图片分析，该技术方案还包括以下特征：`;
            description += '\n1. 模块化设计，便于组装和维护；';
            description += '\n2. 采用标准化接口，提高兼容性；';
            description += '\n3. 结构紧凑，空间利用率高。';
        }

        if (background) {
            description += `\n\n结合背景信息"${background.substring(0, 50)}${background.length > 50 ? '...' : ''}"，`;
            description += '该技术方案能够有效解决相关技术问题，具有较好的实用价值。';
        }

        description += '\n\n[注: 以上为Mock数据，实际描述将由AI模型生成]';

        return description;
    }
}
